import { Button } from "react-bootstrap";
import { useState } from "react";
import { formatRangeDateForApi } from "../helpers/utils";

const DeleteFromSummaryButton = ({ range }) => {
    const [loading, setLoading] = useState(false);

    const handleDeleteFromSummary = async () => {
        const start = formatRangeDateForApi(range.startDate);
        const end = formatRangeDateForApi(range.endDate);

        if (!window.confirm(`Видалити дані з ${start} по ${end}?`)) return;

        setLoading(true);

        try {
            const res = await fetch("/api/delete-range", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ start, end, confirm: true }),
            });

            if (!res.ok) throw new Error("Помилка при видаленні");

            alert("🗑 Дні успішно видалені з БД");
        } catch (err) {
            console.error("❌ Помилка при видаленні:", err);
            alert("Помилка при видаленні днів");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            variant="danger"
            className="ms-2"
            onClick={handleDeleteFromSummary}
            // disabled={true}
        >
            {loading ? "Видалення..." : "Видалити дні з БД"}
        </Button>
    );
};

export default DeleteFromSummaryButton;
